<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<ng-container *ngIf='!dataLoading'>
  <div mat-dialog-title>
    <h2>{{"reviews.Mark as Resolved" | translate}}</h2>
    <button mat-icon-button (click)="openConfirmDialog()" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="formGroup">
    <mat-dialog-content>
      <div class="mat-dialog-body">

        <div class="fields-group">
          <h4 class="group-title">{{"reviews.What is your decision about the reported content?" | translate}}</h4>
          <mat-radio-group class="radio-horizontal-group list-has-fields" formControlName="decisionType">
            <mat-radio-button [value]="'Keep'">{{"reviews.Keep it" | translate}}</mat-radio-button>
            <mat-radio-button [value]="'Hide'">{{"reviews.Remove it" | translate}}</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="fields-group">
          <h4 class="group-title">{{"reviews.Have Notes?" | translate}}</h4>
          <mat-form-field>
            <mat-label>{{"forms.Notes" | translate}}</mat-label>
            <textarea matInput formControlName="decisionComment" maxlength="300"></textarea>
            <mat-error *ngIf="hasError('decisionComment', 'required')">{{ 'forms.Required' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>

    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button type="button" (click)="openConfirmDialog()" class="btn-grey">
        {{"forms.Cancel" | translate}}</button>

      <button (click)="saveRecord()" mat-raised-button color="primary"
        [disabled]="loading" [class.loading]="loading">
        {{"reviews.Submit Decision" | translate}}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
